import { isSet } from '../utils/isSet';

class ContentNav {
    constructor() {
        this.init();

        this.checkBottomOffset = this.checkBottomOffset.bind(this);
        window.addEventListener(
            'scroll', 
            this.checkBottomOffset
        );
    }

    init(){
        const content = document.querySelector('.hentry');
        const sections = content.querySelectorAll('[data-label]');
        const menus = document.querySelectorAll('.target-content-menu--js');
        
        const li__list = []

        sections.forEach((section) => {
            const label = section.dataset.label;
            if(!isSet(label) || label === '') return;

            const id = section.id;
            if(!isSet(id) || id === '') return;

            const labels = label.split(',');

            labels.forEach((label) => {
                const li__Elm = document.createElement('li');
                const a__Elm = document.createElement('a');
                const span__Elm = document.createElement('span');

                span__Elm.textContent = label;

                a__Elm.href = '#' + id;
                a__Elm.append(span__Elm);
                a__Elm.insertAdjacentHTML('afterbegin', '<svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.56 0.00612812C3.67867 0.0261629 3.78456 0.0924444 3.85443 0.190437C3.9243 0.288429 3.95246 0.410132 3.93273 0.528855L3.64182 2.27249H7.26636L7.58182 0.379765C7.60471 0.263822 7.67186 0.161355 7.76903 0.0940885C7.8662 0.026822 7.98575 4.52538e-05 8.10233 0.0194358C8.21891 0.0388263 8.32336 0.102859 8.39352 0.197958C8.46368 0.293057 8.49405 0.411744 8.47818 0.528855L8.18727 2.27249H9.54545C9.66601 2.27249 9.78162 2.32038 9.86687 2.40562C9.95211 2.49087 10 2.60648 10 2.72704C10 2.84759 9.95211 2.96321 9.86687 3.04845C9.78162 3.13369 9.66601 3.18158 9.54545 3.18158H8.03636L7.43091 6.81795H8.78818C8.90874 6.81795 9.02435 6.86584 9.10959 6.95108C9.19484 7.03632 9.24273 7.15194 9.24273 7.27249C9.24273 7.39304 9.19484 7.50866 9.10959 7.5939C9.02435 7.67915 8.90874 7.72704 8.78818 7.72704H7.27909L6.96364 9.61977C6.95547 9.68006 6.93527 9.7381 6.90426 9.79044C6.87324 9.84279 6.83203 9.88837 6.78307 9.9245C6.73411 9.96062 6.67839 9.98655 6.61923 10.0007C6.56006 10.0149 6.49865 10.0171 6.43863 10.0071C6.37861 9.99713 6.3212 9.9752 6.26982 9.94262C6.21843 9.91004 6.17411 9.86748 6.13947 9.81745C6.10484 9.76742 6.08061 9.71095 6.06821 9.65138C6.0558 9.59182 6.05549 9.53036 6.06727 9.47067L6.35818 7.72704H2.73273L2.41727 9.61977C2.40748 9.67868 2.38619 9.73509 2.3546 9.78578C2.323 9.83646 2.28174 9.88043 2.23316 9.91516C2.18458 9.9499 2.12963 9.97473 2.07145 9.98823C2.01327 10.0017 1.95301 10.0036 1.89409 9.99386C1.83518 9.98407 1.77876 9.96277 1.72808 9.93118C1.67739 9.89959 1.63343 9.85832 1.59869 9.80974C1.56395 9.76116 1.53912 9.70621 1.52562 9.64803C1.51212 9.58986 1.51021 9.52959 1.52 9.47067L1.81182 7.72704H0.454545C0.333993 7.72704 0.218377 7.67915 0.133133 7.5939C0.0478896 7.50866 0 7.39304 0 7.27249C0 7.15194 0.0478896 7.03632 0.133133 6.95108C0.218377 6.86584 0.333993 6.81795 0.454545 6.81795H1.96364L2.56909 3.18158H1.21182C1.09127 3.18158 0.97565 3.13369 0.890406 3.04845C0.805162 2.96321 0.757273 2.84759 0.757273 2.72704C0.757273 2.60648 0.805162 2.49087 0.890406 2.40562C0.97565 2.32038 1.09127 2.27249 1.21182 2.27249H2.72091L3.03636 0.379765C3.05619 0.260925 3.12238 0.154816 3.22039 0.0847555C3.31841 0.0146949 3.44023 -0.0135859 3.55909 0.00612812M3.49091 3.18158L2.88545 6.81795H6.50909L7.11455 3.18158H3.49091Z" fill="#2DABFF"/></svg>');

                li__Elm.append(a__Elm);

                li__list.push(li__Elm);
            });
        });

        menus.forEach((menuElm) => {
            li__list.forEach((li) => {
                menuElm.append(li.cloneNode(true));
            });
        })
    }

    checkBottomOffset(e){
        const floatingContentNav = document.querySelector('#floating-nav');

        if ((window.innerHeight + Math.round(window.scrollY)) >= document.body.offsetHeight) {
            floatingContentNav.classList.add('is-offscreen');
        } else{
            floatingContentNav.classList.remove('is-offscreen');
        }
    }
}

export { ContentNav }